import * as UI from '@brewlogix/blx-ui'
import classNames from 'classnames'
import React from 'react'
import { Checkbox } from '@chakra-ui/react'
import { useFilterStore } from '../../state/filterStore'

const HoursOfOperation: React.FC = () => {
    const toggleHoursArrowUp = useFilterStore((state) => state.toggleHoursArrowUp)
    const setToggleHoursArrowUp = useFilterStore((state) => state.setToggleHoursArrowUp)
    const setOpenNowHours = useFilterStore((state) => state.setOpenNowHours)
    const openNowHours = useFilterStore((state) => state.openNowHours)
    const setFilterCount = useFilterStore((state) => state.setFilterCount)

    const handleFilterSelection = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.checked) {
            setOpenNowHours(false)
        } else {
            setOpenNowHours(true)
        }

        setFilterCount()
    }
    return (
        <div
            className={classNames(
                'flex flex-col items-start justify-start',
                toggleHoursArrowUp ? 'mb-2' : ''
            )}
        >
            <UI.Button
                label='Hours Options'
                theme='link'
                customClasses='flex flex-row-reverse justify-start text-dark pb-0 pl-0'
                onClick={() => setToggleHoursArrowUp(!toggleHoursArrowUp)}
                size='sm'
            >
                <UI.Icon
                    slug='HeroIcons.ChevronRight'
                    size='sm'
                    customClasses={classNames(
                        toggleHoursArrowUp ? '-rotate-90' : '',
                        'text-gray-300 mr-2 pointer-events-none'
                    )}
                />
            </UI.Button>

            <div
                className={classNames(
                    !toggleHoursArrowUp ? 'hidden' : '',
                    'flex flex-col overflow-hidden pl-1',
                    openNowHours ? 'h-auto' : 'max-h-[8.5rem]'
                )}
            >
                <div key={`filterOption-hours`} className='flex flex-col pb-2'>
                    <Checkbox
                        className='hours-filter pt-2'
                        id={`filterHours-Hours-0`}
                        onChange={handleFilterSelection}
                        isChecked={openNowHours}
                        colorScheme='gray'
                    >
                        Open Now
                    </Checkbox>
                </div>
            </div>
        </div>
    )
}
export default HoursOfOperation
